import operation from "./operation";
import { OperationVars } from "@/types/operation";

const m = <Vars>(name: string, vars: OperationVars<Vars>) =>
  operation<Vars>("mutation", name, vars);

export default m;
